var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStoreListingEmptyState = function SvgStoreListingEmptyState(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 410,
    height: 286,
    viewBox: "0 0 410 286",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_599_109505)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.3875,
    y: 47.209,
    width: 178.842,
    height: 219.842,
    rx: 11.0012,
    transform: "rotate(-13.7501 15.3875 47.209)",
    fill: "white",
    stroke: "#EEEEEE",
    strokeWidth: 1.15802
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.4271,
    height: 6.94825,
    rx: 3.47413,
    transform: "matrix(0.97075 -0.240091 0.244543 0.969639 70.2852 189.843)",
    fill: "#D7E7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.6518,
    height: 6.94825,
    rx: 3.47413,
    transform: "matrix(0.97075 -0.240091 0.244543 0.969639 80.9805 233.552)",
    fill: "#D7E7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 138.854,
    height: 6.94825,
    rx: 3.47413,
    transform: "matrix(0.97075 -0.240091 0.244543 0.969639 73.6836 203.318)",
    fill: "#F3F8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 102.89,
    height: 6.94825,
    rx: 3.47413,
    transform: "matrix(0.97075 -0.240091 0.244543 0.969639 77.0742 217.183)",
    fill: "#F3F8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.4219,
    y: 59.752,
    width: 143,
    height: 114,
    rx: 10,
    transform: "rotate(-13.7501 37.4219 59.752)",
    fill: "#E2EEFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_599_109505)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.681,
    y: 8.67323,
    width: 178.842,
    height: 219.842,
    rx: 11.0012,
    transform: "rotate(10.3029 218.681 8.67323)",
    fill: "white",
    stroke: "#EEEEEE",
    strokeWidth: 1.15802
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.4271,
    height: 6.94825,
    rx: 3.47413,
    transform: "matrix(0.984316 0.176417 -0.171899 0.985115 210.676 161.297)",
    fill: "#D7E7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.6518,
    height: 6.94825,
    rx: 3.47413,
    transform: "matrix(0.984316 0.176417 -0.171899 0.985115 202.629 205.569)",
    fill: "#D7E7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 138.854,
    height: 6.94825,
    rx: 3.47413,
    transform: "matrix(0.984316 0.176417 -0.171899 0.985115 208.285 174.987)",
    fill: "#F3F8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 102.89,
    height: 6.94825,
    rx: 3.47413,
    transform: "matrix(0.984316 0.176417 -0.171899 0.985115 205.734 189.03)",
    fill: "#F3F8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.688,
    y: 29.1084,
    width: 143,
    height: 114,
    rx: 10,
    transform: "rotate(10.3029 233.688 29.1084)",
    fill: "#E2EEFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_599_109505)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.267,
    y: 15.579,
    width: 178.842,
    height: 219.842,
    rx: 11.0012,
    fill: "white",
    stroke: "#EEEEEE",
    strokeWidth: 1.15802
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.4271,
    height: 6.94825,
    rx: 3.47413,
    transform: "matrix(0.999997 -0.00247508 0.00706334 0.999975 134.688 167.174)",
    fill: "#D7E7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.6518,
    height: 6.94825,
    rx: 3.47413,
    transform: "matrix(0.999997 -0.00247508 0.00706334 0.999975 134.688 212.172)",
    fill: "#D7E7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 138.854,
    height: 6.94825,
    rx: 3.47413,
    transform: "matrix(0.999997 -0.00247508 0.00706334 0.999975 134.785 181.07)",
    fill: "#F3F8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 102.89,
    height: 6.94825,
    rx: 3.47413,
    transform: "matrix(0.999997 -0.00247508 0.00706334 0.999975 134.785 195.344)",
    fill: "#F3F8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.688,
    y: 33,
    width: 143,
    height: 114,
    rx: 10,
    fill: "#E2EEFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_599_109505",
    x: 0.893131,
    y: 0.627848,
    width: 254.96,
    height: 285.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.4222
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.10617
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_599_109505"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_599_109505",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_599_109505",
    x: 164.358,
    y: 4.09269,
    width: 245.284,
    height: 278.29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.4222
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.10617
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_599_109505"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_599_109505",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_599_109505",
    x: 98.4752,
    y: 9.20988,
    width: 212.425,
    height: 253.425,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.4222
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.10617
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_599_109505"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_599_109505",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStoreListingEmptyState);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "store-listing-empty-state.9b6d3f5ae479561459c78d8e27bb314d.svg";